module.exports = "<template>\n    <div>\n        <vbl-breadcrumb>\n            <vbl-breadcrumb-item to=\"/\">首页</vbl-breadcrumb-item>\n            <vbl-breadcrumb-item to=\"/detail\">详情页</vbl-breadcrumb-item>\n            <vbl-breadcrumb-item>编辑</vbl-breadcrumb-item>\n        </vbl-breadcrumb>\n    </div>\n</template>\n\n<script>\nexport default {\n};\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/vblBreadcrumb/example/vblBreadcrumbExample.vue
// module id = 161
// module chunks = 0